var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22969 14.6H13.7703V13.4H7.22969V14.6ZM7.22969 11.2H13.7703V10H7.22969V11.2ZM5.21875 18C4.89375 18 4.60937 17.88 4.36562 17.64C4.12187 17.4 4 17.12 4 16.8V3.2C4 2.88 4.12187 2.6 4.36562 2.36C4.60937 2.12 4.89375 2 5.21875 2H12.5516L17 6.38V16.8C17 17.12 16.8781 17.4 16.6344 17.64C16.3906 17.88 16.1062 18 15.7812 18H5.21875ZM11.9422 6.92V3.2H5.21875V16.8H15.7812V6.92H11.9422Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.16c8f5dae882ee7831a8d26b745f965b.svg";
export { ForwardRef as ReactComponent };